<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">New fitness data</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <mat-dialog-content style="padding-bottom: 0px;padding-top: 10px;">
  <div class="sb_top">
        <p class="sub_para" style="margin-bottom: 25px;">
          Data helps gym instructor and member understand what works for their body. You can add weight, height, chest, waist, hips, arms, thighs, lift progress, workout benchmarks, endurance metrics etc.</p>
  </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Data name</mat-label>
        <input matInput #input [(ngModel)]="trackingName"/>
      </mat-form-field>
    </div>
      <div>
      <mat-form-field appearance="outline">
        <mat-label>Measurement unit</mat-label>
        <input matInput #input [(ngModel)]="measurementUnit" />
      </mat-form-field>
    </div>

      <div>
      <mat-form-field appearance="outline">
        <mat-label>Current Value</mat-label>
        <input matInput #input [(ngModel)]="currentValue" [type]="typenumber ?  'number' : 'text'"/>
      </mat-form-field>
    </div>
  <div class="sb_top margin-tp">
        <p class="sub_para">
           Track progress of the above data. So that it transforms fitness from a vague concept of 'working out' into a targeted, results-driven process.</p>
  </div>
    <div class="track_checked">
          <mat-checkbox (change)="onchange($event)" [(ngModel)]="trackingStatus"  class="example-margin">Yes, track progress.</mat-checkbox>
         </div>
    </mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="accent" [disabled]="!trackingName || !currentValue"  (click)="onSave()">Save</button>
</mat-dialog-actions>